import { useEffect } from 'react'
import { useWebsocketConnection } from 'providers/WebsocketProvider'
import { ActivityEvent } from 'components/ActivityEvent/Types'

const WS_CHANNEL_NAME = 'Articles::TimelineEventsChannel'

interface Payload {
  event: ActivityEvent
}

export const useArticleEventsRealtimeChannel = (
  articleKey: string,
  receiveRealtimeUpdates: boolean = false,
  onReceive: (event: Payload['event']) => void,
) => {
  const websocketConnection = useWebsocketConnection()

  useEffect(() => {
    if (!websocketConnection) {
      return
    }
    if (!receiveRealtimeUpdates) {
      return
    }

    const subscription = websocketConnection.subscriptions.create(
      {
        channel: WS_CHANNEL_NAME,
        id: articleKey,
      },
      {
        received: ({ event }: Payload) => {
          onReceive(event)
        },
      },
    )

    return () => {
      subscription.unsubscribe()
    }
  }, [websocketConnection, articleKey, onReceive, receiveRealtimeUpdates])
}
